import * as React from "react";
import { Box, styled } from "@mui/system";
import { Typography } from "@mui/material";
import ParallaxComponent from "./entryScreenComponents/parallax";
import { useTranslation } from "react-i18next";
import ClientsSection from "./entryScreenComponents/clientsSection";
import entryImage from "../../../assets/entryImageTemp.jpg";
import { ReactComponent as GWINLogo } from "../../../assets/gwinlogo.svg";

export default function EntryScreen() {
  const { t } = useTranslation();
  return (
    <Box>
      <ParallaxComponent image={entryImage} title={<GWINLogo />} />
      <DescriptionSection>
        <DescriptionBox>
          <Block>
            <Title id='gwin-biosense' variant='h3'>
              <GWINLogo />
            </Title>
            <Subtitle variant='h6'>IoT-Powered Botanical Management</Subtitle>
          </Block>
          <TopicText>{t("entry.content_gwintext")}</TopicText>
          {process.env.NODE_ENV === "development" && (
            <>
              <Block>
                <Title id='about-8p' variant='h3'>
                  {t("entry.content_about8p")}
                </Title>
                <Subtitle variant='h6'>Since 1999</Subtitle>
              </Block>
              <TopicText>{t("entry.content_about8ptext")}</TopicText>
              <Block>
                <Title id='clients' variant='h3'>
                  {t("entry.content_clients")}
                </Title>
              </Block>
              <ClientsSection />
              <Block>
                <Title id='contact' variant='h3'>
                  {t("entry.content_contact")}
                </Title>
              </Block>
              <TopicText>
                Here is some description text about the content shown above. You can add more
                paragraphs, links, or other elements as per your requirements.
              </TopicText>
            </>
          )}
        </DescriptionBox>
      </DescriptionSection>
    </Box>
  );
}

const DescriptionSection = styled(Box)(({ theme }) => ({
  backgroundColor: "#E0E0E0",
  padding: theme.spacing(4),
  display: "flex",
  flexDirection: "column",
  paddingTop: "2em",
  paddingBottom: "2em",
  alignItems: "center",
}));

const DescriptionBox = styled(Box)(({ theme }) => ({
  width: "80%",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  rowGap: "5em",
}));

const Title = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

const Subtitle = styled(Typography)(({ theme }) => ({
  color: "grey",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));
const TopicText = styled(Typography)(({ theme }) => ({
  textAlign: "left", // Align text within the block to the left
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  maxWidth: "40em",
  margin: "0 auto",
  padding: theme.spacing(1),
}));

const Block = styled(Box)(({ theme }) => ({}));
